import { makeObservable } from 'mobx'

import { ICompany } from '~/client/graph'
import CompanyFieldId from '~/client/src/desktop/enums/CompanyFieldId'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'
import WhiteListItemsStore from '~/client/src/shared/stores/domain/WhiteListItems.store'

import AddEditCompanyDialogStore from './AddEditCompanyDialog.store'

export default class MergeCompanyDialogStore extends AddEditCompanyDialogStore {
  public constructor(
    itemsToEdit: ICompany[],
    items: ICompany[],
    resetErrorMessage: () => void,
    updateItems: (items: ICompany[], lastUpdatedCompanyId: string) => void,
    closeDialog: () => void,
    projectMembersStore: ProjectMembersStore,
    whiteListItemsStore: WhiteListItemsStore,
    companiesStore: CompaniesStore,
    readonlyFieldIds?: CompanyFieldId[],
  ) {
    super(
      itemsToEdit,
      items,
      resetErrorMessage,
      updateItems,
      closeDialog,
      projectMembersStore,
      whiteListItemsStore,
      companiesStore,
      readonlyFieldIds,
    )

    makeObservable(this)
  }

  public handlePreClose() {
    this.closeDialog()
  }

  public handleCloseConfirmModal() {
    this.hideConfirmModal()
  }

  public preSubmit() {
    this.showConfirmModal()
  }

  public submit() {
    this.hideConfirmModal()

    this.setFieldsToItem(this.editingItem, this.activeFormStore.fields)

    const itemsToUpdate = this.itemsToEdit.slice()

    this.updateItems(itemsToUpdate, this.activeItemId)
  }

  public get canFormsBeSubmitted(): boolean {
    return super.areAllRequiredFieldsFilled && !super.hasActiveFormError
  }

  public get okActionCaption(): string {
    return Localization.translator.merge_verb
  }

  public get confirmationDoneBtnTitle(): string {
    return Localization.translator.merge_verb
  }

  public get confirmationMessage(): string {
    const sourceCompaniesNames = this.itemsToEdit
      .filter(c => c.id !== this.activeItemId)
      .map(c => `[${c.name}]`)

    const targetCompanyName = this.getFieldValueById(CompanyFieldId.Name)

    return Localization.translator.companyMerging.confirmation(
      sourceCompaniesNames.join(', '),
      `[${targetCompanyName}]`,
    )
  }

  public get dialogCaption(): string {
    return Localization.translator.targetCompany
  }
}
